import cn from 'classnames'

import { useCallback, useEffect, useState } from 'react'

import dynamic from 'next/dynamic'

import { useRouter } from 'next/router'

import { useHeader } from '../../utils/use-header'

import ExchangeFaq from '../exchange/exchange-faq'

import { useAppSelector } from '../../store/hooks'
import { LoginStatuses, selectedAuthStatus } from '../../store/reducers/users'

import useLocationSearch from '../../libs/location-search'

import { saveReferralId } from '../../libs/local-storage'

import InviteFriends from './invite-friends'
import Advantages from './advantages'
import GetReward from './get-reward'
import WhyInvite from './why-invite'
import HowUse from './how-use'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

const LoginForm = dynamic(() => import('../../components/ui/header/components/popup-login-form'), { ssr: false })

const POPUP_TYPE_LOANS = 'loans'

export default function ReferralPage() {
  const { t } = useTranslation()
  const [isOpenLoginBlock, setIsOpenLoginBlock] = useState(false)
  const query = useLocationSearch()
  const referralId = Array.isArray(query.referral) ? query.referral[0] : query.referral

  const authStatus = useAppSelector(selectedAuthStatus)
  const router = useRouter()

  useEffect(() => {
    if (referralId) {
      saveReferralId(referralId)
    }
  }, [referralId])

  const handleClosePopup = useCallback(() => {
    setIsOpenLoginBlock(false)
  }, [])

  const handleGoToRefferal = async () => {
    if (authStatus === LoginStatuses.LOGIN) {
      await router.push({
        pathname: '/account/referral',
      })
    } else {
      setIsOpenLoginBlock(true)
    }
  }

  const head = useHeader(
    t('referral_program'),
    t('invite_friends_sign_up'),
  )

  const questions = [
    {
      title: t('what_is_exchange'),
      answer: t('what_is_exchange_answer'),
    },
    {
      title: t('how_trade'),
      answer: t('how_trade_answer'),
    },
    {
      title: t('what_affects'),
      answer: t('what_affects_answer'),
    },
    {
      title: t('how_exchange'),
      answer: t('how_exchange_answer'),
    },
  ]

  return (
    <div className={styles.referral}>
      {head}
      <section className={cn(styles.section, styles.section_invite)}>
        <InviteFriends handleGoToRefferal={handleGoToRefferal} />
      </section>

      <section className={cn(styles.section, styles.section_advantages)}>
        <Advantages />
      </section>

      <section className={styles.section}>
        <div className={styles.section__header}>
          <h2 className={cn(styles.section__title)}>{t('get_reward_steps')}</h2>
        </div>
        <GetReward />
      </section>

      <section className={styles.section}>
        <div className={styles.section__header}>
          <h2 className={cn(styles.section__title)}>{t('invite_coinrabbit')}</h2>
        </div>
        <WhyInvite handleGoToRefferal={handleGoToRefferal} />
      </section>

      <section className={styles.section}>
        <div className={styles.section__header}>
          <h2 className={cn(styles.section__title, styles.section__title_left)}>{t('use_referral_links')}</h2>
        </div>
        <HowUse handleGoToRefferal={handleGoToRefferal} />
      </section>

      <section className={styles.section}>
        <div className={styles.section__header}>
          <h2 className={cn(styles.section__title, styles.section__title_left)}>{t('faq')}</h2>
        </div>
        <ExchangeFaq questions={questions} />
      </section>

      {isOpenLoginBlock && <LoginForm isWallet={false} onCloseForm={handleClosePopup} type={POPUP_TYPE_LOANS} />}
    </div>
  )
}
